var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {DelAuthorizedUserAsync as InvokeAsync , DelAuthorizedUserSync as InvokeSync}

async function DelAuthorizedUserAsync(LoginToken,DeviceUUID,UserEmail)
{
    var DelAuthorizedUserPromise = new Promise((resolve, reject) => {
        DelAuthorizedUserSync(LoginToken,DeviceUUID,UserEmail,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await DelAuthorizedUserPromise;
}

function DelAuthorizedUserSync(LoginToken,DeviceUUID,UserEmail,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Device/DeleteAuthorizedUser',                
        data  : {
            DeviceUUID   : DeviceUUID  ,
            LoginToken   : LoginToken  ,
            UserEmail    : UserEmail   ,
            AppID        : KEYS.AWS_APPID              
        }                                    
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}



